<template>
  <div class="wrap">
    <!-- <div class="headers">
      <div class="logo">
        <a href="https://bluexad.ai/" target="_blank">
          <img src="../../assets/img/logo_col.png">
          <span class="logo-text">| {{$t("login.logoDevPlatform")}}</span>
        </a>
      </div>
    </div> -->

    <div class="header-right">
      <div class="header-user-con">
        <el-dropdown trigger="click" @command="langChange">
          <span class="el-dropdown-link">
            {{language}} <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided command="zh">中文</el-dropdown-item>
            <el-dropdown-item divided command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="fg-card">
      <!-- active 从 0 开始：step-1 让当前步骤落在 is-process（实心蓝），走过的是 is-finish（浅蓝） -->
      <el-steps class="fg-steps" :active="step - 1" align-center>
        <el-step :title="$t('forget.stepVerify')"></el-step>
        <el-step :title="$t('forget.stepNewPwd')"></el-step>
        <el-step :title="$t('forget.stepDone')"></el-step>
      </el-steps>

      <!-- Step1 验证身份 -->
      <div v-if="step === 1">
        <p class="fg-title">{{$t('forget.pageTitle')}}</p>
        <p class="fg-desc">{{$t('forget.pageDesc')}}</p>
        <el-form :model="form" :rules="step1Rules" ref="step1Ref" class="ms-content" size="large">
          <el-form-item label class="signupRadio">
            <el-radio-group v-model="verify_type">
              <el-radio-button :label="2">{{$t('forget.verifyByEmail')}}</el-radio-button>
              <el-radio-button :label="1">{{$t('forget.verifyByPhone')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label prop="email" v-if="verify_type === 2">
            <el-input
              v-model.trim="form.email"
              :placeholder="$t('forget.Email')"
              prefix-icon="el-icon-message"
              @input="accountNotFound = false"
            ></el-input>
            <!-- 未注册跳转到注册页面 -->
            <div class="field-error" v-if="accountNotFound">
              {{$t('forget.notRegisteredEmail')}}
              <span class="field-error__link" @click="goSignup">{{$t('forget.goSignup')}}</span>
            </div>
          </el-form-item>
          <el-form-item label prop="mobile" v-if="verify_type === 1">
            <div class="phone-row">
              <el-select class="phone-row__itu" v-model="form.itu_code">
                <el-option
                  v-for="item in ituList"
                  :key="item.value"
                  :label="`${item.value}`"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input
                class="phone-row__input"
                v-model.trim="form.mobile"
                :placeholder="$t('forget.telPlaceholder')"
                prefix-icon="el-icon-mobile"
                @input="accountNotFound = false"
              ></el-input>
            </div>
            <div class="field-error" v-if="accountNotFound">
              {{$t('forget.notRegisteredPhone')}}
              <span class="field-error__link" @click="goSignup">{{$t('forget.goSignup')}}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-button" type="primary" @click="handleNext">{{$t('forget.next')}}</el-button>
          </el-form-item>
          <el-form-item>
            <p class="fg-link" @click="goLogin">{{$t('forget.backToLogin')}}</p>
          </el-form-item>
        </el-form>
      </div>

      <!-- Step2 设置新密码 -->
      <div v-if="step === 2">
        <p class="fg-title fg-title--solo">{{$t('forget.resetTitle')}}</p>
        <el-form :model="form" :rules="step2Rules" ref="step2Ref" class="ms-content" size="large">
          <el-form-item label>
            <el-input disabled :value="verify_type === 1 ? form.mobile : form.email">
              <template slot="prepend">{{ verify_type === 1 ? form.itu_code : $t('forget.Email') }}</template>
            </el-input>
          </el-form-item>
          <el-form-item class="captcha" label prop="captcha">
            <el-input
              v-model.trim="form.captcha"
              prefix-icon="el-icon-check"
              :placeholder="$t('login.imgCode')"
            ></el-input>
            <div class="captcha-img">
              <img :src="captchaUrl" />
              <div @click="handleCaptcha" class="cover"></div>
            </div>
          </el-form-item>
          <el-form-item class="send-code-info" label prop="sms_code">
            <el-input
              v-model.trim="form.sms_code"
              prefix-icon="el-icon-chat-line-square"
              :placeholder="verify_type === 1 ? $t('forget.msgCode') : $t('forget.emailCode')"
            ></el-input>
            <el-button
              class="send-code-btn"
              type="primary"
              :disabled="sendCodeDisabled"
              @click="handleSendCode"
            >{{ sendCodeBtnName }}</el-button>
          </el-form-item>
          <el-form-item label prop="password">
            <el-input
              type="password"
              show-password
              autocomplete="new-password"
              v-model="form.password"
              prefix-icon="el-icon-lock"
              :placeholder="$t('login.setPwd')"
            ></el-input>
          </el-form-item>
          <el-form-item label prop="confirm_password">
            <el-input
              type="password"
              show-password
              autocomplete="new-password"
              v-model="form.confirm_password"
              prefix-icon="el-icon-lock"
              :placeholder="$t('forget.confirmPwdPh')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-button" type="primary" @click="handleReset">{{$t('forget.resetTitle')}}</el-button>
          </el-form-item>
          <el-form-item>
            <!-- 「上一步」回第一步重新填账号，「返回登录」直接放弃找回流程 -->
            <div class="fg-link-group">
              <span class="fg-link" @click="goPrev">{{$t('forget.prevStep')}}</span>
              <i class="fg-link-divider"></i>
              <span class="fg-link" @click="goLogin">{{$t('forget.backToLogin')}}</span>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- Step3 完成 -->
      <div v-if="step === 3" class="fg-done">
        <i class="el-icon-check fg-done__icon"></i>
        <p class="fg-done__title">{{$t('forget.resetSuccess')}}</p>
        <p class="fg-done__desc">{{$t('forget.resetDoneDesc')}}</p>
        <p class="fg-done__countdown">{{ redirectText }}</p>
        <!-- 这个按钮不在 el-form 里，拿不到 form 的 size="large"，要自己声明才能和前两步的按钮一样高 -->
        <el-button class="submit-button" type="primary" size="large" @click="goLogin">{{$t('forget.loginNow')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util'
export default {
  data() {
    return {
      step: 1,
      verify_type: 2, //验证方式:1手机号,2邮箱
      form: {
        email: "",
        itu_code: "+86",
        mobile: "",
        captcha: "", //图形验证码
        sms_code: "", //短信/邮件验证码
        password: "",
        confirm_password: "",
      },
      ituList: [
        { value: "+86",label: "CHN"},
        { value: "+852",label: "HKG"},
        { value: "+853",label: "MAC"},
        { value: "+886",label: "TWN"},
        { value: "+1",label: "USA/CAN"},
        { value: "+7",label: "RUS"},
        { value: "+48",label: "POL"},
        { value: "+60",label: "MYS"},
        { value: "+62",label: "IDN"},
        { value: "+65",label: "SGP"},
        { value: "+84",label: "VNM"},
        { value: "+357",label: "CYP"},
        { value: "+375",label: "BLR"}
      ],
      captchaUrl: "",
      accountNotFound: false, //Step1 存在性校验没过
      sendCodeBtnName: "",
      codeSent: false, //发过一次之后按钮文案从「获取验证码」变「重新获取」
      codeTimer: null, //60 秒发码倒计时
      redirectTimer: null, //Step3 自动跳转倒计时
      redirectLeft: 5,
      language: '中文',
    };
  },
  computed: {
    step1Rules() {
      return {
        email: [{ validator: this.validateEmail, trigger: "blur" }],
        mobile: [{ validator: this.validateMobile, trigger: "blur" }],
      }
    },
    step2Rules() {
      return {
        captcha: [{ required: true, message: this.$t('login.codeCheck'), trigger: "blur" }],
        sms_code: [{
          required: true,
          message: this.verify_type === 1 ? this.$t('forget.smsCheck') : this.$t('forget.verifyCheck'),
          trigger: "blur"
        }],
        password: [
          { required: true, message: this.$t('login.pwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" }
        ],
        confirm_password: [
          { required: true, message: this.$t('login.pwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" },
          { validator: this.validateConfirmPassword, trigger: "blur" }
        ],
      }
    },
    // 图形验证码没填不让点，和登录/重置页一致
    sendCodeDisabled() {
      return !this.form.captcha || !!this.codeTimer
    },
    redirectText() {
      return String(this.$t('forget.autoRedirect')).replace('%s', this.redirectLeft)
    }
  },
  watch: {
    // 换验证方式时把上一种方式的报错带下来会很怪
    verify_type() {
      this.accountNotFound = false
    }
  },
  created() {
    // 从登录页带过来的上下文：type 决定默认选中哪种验证方式，account 是已经敲过的账号
    let query = this.$route.query || {}
    if (query.type == 1) {
      this.verify_type = 1
      this.form.mobile = query.account || ""
      if (query.itu) {
        this.form.itu_code = query.itu
      }
    } else {
      this.verify_type = 2
      this.form.email = query.account || ""
    }
    var lang = localStorage.getItem("lang")
    if(lang == 'en') {
      this.language = 'English'
    } else if (lang == 'zh') {
      this.language = '中文'
    }
    this.sendCodeBtnName = this.$t('forget.getCode')
  },
  beforeDestroy() {
    this.clearCodeTimer()
    this.clearRedirectTimer()
  },
  methods: {
    // 中英文切换
    langChange(command) {
      this.$i18n.locale = command
      localStorage.setItem("lang", command)
      if(command == 'en') {
        this.language = 'English'
      } else if (command == 'zh') {
        this.language = '中文'
      }
      // 倒计时里的文案每秒都会重算，不用管；只有静止状态的按钮文案要跟着换语言
      if (!this.codeTimer) {
        this.sendCodeBtnName = this.codeSent ? this.$t('forget.resend') : this.$t('forget.getCode')
      }
    },
    validateEmail(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('login.emailCheck')));
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error(this.$t('forget.emailFormat')));
      } else {
        callback();
      }
    },
    validateMobile(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('forget.phoneRequired')));
        return
      }
      let reg = /^1[3-9]\d{9}$/
      if (this.form.itu_code != '+86') {
        reg = /^[0-9]{5,16}$/
      }
      if (!reg.test(value)) {
        callback(new Error(this.$t('forget.phoneFormat')));
      } else {
        callback();
      }
    },
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.form.password) {
        callback(new Error(this.$t('forget.reInputPsd')));
      } else {
        callback();
      }
    },
    // Step1 下一步
    handleNext() {
      this.accountNotFound = false
      this.$refs.step1Ref.validate(valid => {
        if (!valid) {
          return
        }
        let params = this.verify_type === 1
          ? { verify_type: 1, mobile: this.form.mobile, itu_code: this.form.itu_code }
          : { verify_type: 2, email: this.form.email }
        this.__postData("forgotPasswordCheck", params, res => {
            if (res.code == 1) {
              this.accountNotFound = true
              return
            }
            this.step = 2
            this.handleCaptcha()
          },
          errmsg => {
            this.$message.error(errmsg);
          }
        );
      })
    },
    // Step2 上一步
    goPrev() {
      this.step = 1
      this.clearCodeTimer()
      this.form.captcha = ""
      this.form.sms_code = ""
      this.form.password = ""
      this.form.confirm_password = ""
      this.captchaUrl = ""
      this.codeSent = false
      this.sendCodeBtnName = this.$t('forget.getCode')
    },
    goSignup() {
      this.$router.push("/signup")
    },
    goLogin() {
      // 手动点「立即登录」时要把自动跳转停掉，不然会再跳一次
      this.clearRedirectTimer()
      this.$router.push("/login")
    },
    handleCaptcha() {
      this.__postData("getCaptcha", {}, res => {
          if(res.code == 1) {
            this.$message.error(res.msg);
          } else {
            this.captchaUrl = res.image_data;
          }
        },
        errmsg => {
          this.$message.error(errmsg);
        }
      );
    },
    // 发短信/邮件验证码
    handleSendCode() {
      if (this.codeTimer) {
        return;
      }
      let params
      if (this.verify_type === 1) {
        params = {
          mobile: this.form.mobile,
          captcha: this.form.captcha,
          itu_code: this.form.itu_code,
          type: 4, //1注册,2登录,3重置密码，4忘记密码
        };
      } else {
        params = {
          email: this.form.email,
          captcha: this.form.captcha,
          type: 4, //1注册,2登录,3重置密码，4忘记密码
        };
      }
      this.__postData(this.verify_type === 1 ? "getSms" : "getEmailCode", params, res => {
          if (res.code == 1) {
            this.$message.error(res.msg || this.$t('forget.captchaWrong'))
            this.handleCaptcha()
            return
          }
          this.$message.success(this.verify_type === 1 ? this.$t('login.msg1') : this.$t('login.msg10'));
          this.codeSent = true
          let count = 60;
          this.sendCodeBtnName = this.codeBtnCounting(count)
          this.codeTimer = setInterval(() => {
            count--;
            if (count > 0) {
              this.sendCodeBtnName = this.codeBtnCounting(count)
            } else {
              this.clearCodeTimer()
              this.sendCodeBtnName = this.$t('forget.resend')
            }
          }, 1000);
        },
        errmsg => {
          this.$message.error(errmsg);
        }
      );
    },
    codeBtnCounting(count) {
      return String(this.$t('forget.resendPattern')).replace('%s', count)
    },
    handleReset() {
      this.$refs.step2Ref.validate(valid => {
        if (!valid) {
          this.$message.error(this.$t('message.errorComplete'));
          return
        }
        let params = {
          verify_type: this.verify_type, //验证类型:1短信,2邮箱
          captcha: this.form.captcha,
          sms_code: this.form.sms_code,
          new_password: this.form.password,
        }
        if (this.verify_type === 1) {
          params.mobile = this.form.mobile
          params.itu_code = this.form.itu_code
        } else {
          params.email = this.form.email
        }
        this.__postData("forgotPasswordReset", params, res => {
            if (res.code == 1) {
              this.$message.error(res.msg);
              return
            }
            this.goDone()
          },
          errmsg => {
            this.$message.error(errmsg);
          }
        );
      })
    },
    goDone() {
      this.step = 3
      this.clearCodeTimer()
      // 后端会把这个账号在所有设备上的登录态踢掉，本机 cookie 里可能还躺着一份旧的，
      // 不删的话跳回登录页会被守卫当成已登录直接放进去
      util.delCookie("token")
      util.delCookie("user")
      this.redirectLeft = 5
      this.redirectTimer = setInterval(() => {
        this.redirectLeft--
        if (this.redirectLeft <= 0) {
          this.goLogin()
        }
      }, 1000)
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer)
        this.codeTimer = null
      }
    },
    clearRedirectTimer() {
      if (this.redirectTimer) {
        clearInterval(this.redirectTimer)
        this.redirectTimer = null
      }
    },
  }
};
</script>

<style scoped lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: #f6f8fa;
}
.headers {
  padding-left: 2%;
  padding-top: 2%;
}
.headers .logo {
  margin: 26px;
}
.headers .logo img {
  height: 45px;
}
.headers .logo a {
  color: #fff;
  float: left;
  display: flex;
  align-items: flex-end;
}
.logo-text {
  font-size: 20px;
  font-weight: 600;
  color: #0B1D40;
  margin-left: 10px;
  white-space: nowrap;
}
.header-right {
  position: absolute;
  top: 12px;
  right: 60px;
  z-index: 10;
}
.header-right .el-dropdown {
  color: rgba(0, 0, 0, 0.85);
}
::v-deep .el-dropdown {
  cursor: pointer;
}

.fg-card {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 494px;
  padding: 30px 47px;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 6px;
}
.fg-steps {
  margin-bottom: 30px;
}
/* 步骤条：Element 默认是「空心圆 + 彩色描边」，设计稿要的是实心圆，整体覆盖一遍。
   三种状态对应 Element 的 is-finish（已完成）/ is-process（当前）/ is-wait（未到） */
.fg-steps /deep/ .el-step__icon.is-text {
  width: 32px;
  height: 32px;
  border: none;
  font-size: 14px;
  font-weight: 500;
}
.fg-steps /deep/ .el-step__head.is-finish .el-step__icon.is-text {
  background: #E6ECFF;
  color: #8CA0E8;
}
.fg-steps /deep/ .el-step__head.is-process .el-step__icon.is-text {
  background: #3361FF;
  color: #FFFFFF;
}
.fg-steps /deep/ .el-step__head.is-wait .el-step__icon.is-text {
  background: #F2F3F5;
  color: #C9CDD4;
}

/* 连接线。圆圈变成 32px 后要把线重新居中（top = 半径 - 线宽/2），
   左右各让出 24px 让线和圆圈之间留空隙 */
.fg-steps /deep/ .el-step__line {
  height: 2px;
  top: 15px;
  background-color: #E5E6EB;
}
.fg-steps /deep/ .el-step.is-center .el-step__line {
  left: calc(50% + 24px);
  right: calc(-50% + 24px);
}
.fg-steps /deep/ .el-step__head.is-finish .el-step__line {
  background-color: #BFCEFF;
}
/* Element 会在 line 里再用 border 画一条进度线，和上面的背景色打架，关掉 */
.fg-steps /deep/ .el-step__line-inner {
  border-width: 0 !important;
}

/* 步骤标题：只有当前步骤是深色 */
.fg-steps /deep/ .el-step__title {
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 0;
  font-weight: 400;
  color: #86909C;
}
.fg-steps /deep/ .el-step__title.is-process {
  color: #1D2129;
  font-weight: 500;
}
.fg-title {
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  text-align: center;
}

.fg-title--solo {
  margin-bottom: 20px;
}
.fg-desc {
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  color: #9b9b9c;
  margin-bottom: 30px;
}
.fg-link {
  width: 100%;
  font-size: 14px;
  color: #3361FF;
  cursor: pointer;
  text-align: center;
}
/* 两个文字链并排时不要各自撑满一行，宽度交给内容 */
.fg-link-group {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fg-link-group .fg-link {
  width: auto;
}
/* 中间那条竖分割线 */
.fg-link-divider {
  width: 1px;
  height: 12px;
  margin: 0 16px;
  background: #E4E7ED;
}
/* 表单最后一项不需要下间距*/
.ms-content /deep/ .el-form-item:last-child {
  margin-bottom: 0;
}
.submit-button {
  width: 100%;
  font-size: 14px;
  border-radius: 6px;
}

/* 自己画的行内报错，对齐 element 的 .el-form-item__error */
.field-error {
  padding-top: 4px;
  font-size: 12px;
  line-height: 1.4;
  color: #F56C6C;
}
.field-error__link {
  color: #3361FF;
  cursor: pointer;
}

/* 验证方式切换：分段控件。整组一圈边框，未选中浅灰底灰字，选中白底蓝字 */
.signupRadio /deep/ .el-radio-group {
  width: 100%;
  display: flex;
  border: 1px solid #E4E7ED;
  border-radius: 6px;
  overflow: hidden;
}
.signupRadio /deep/ .el-radio-button {
  flex: 1;
}
.signupRadio /deep/ .el-radio-button__inner {
  width: 100%;
  height: 38px;
  line-height: 38px;
  padding: 0;
  border: none;
  border-radius: 0;
  background: #F5F7FA;
  color: #8C939D;
  font-size: 14px;
  box-shadow: none !important;
}
.signupRadio /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #FFFFFF;
  color: #3361FF;
  box-shadow: none !important;
}

/* 区号 + 手机号：视觉上连成一个整体。
   负 margin 把相邻的两条 1px 边框叠成一条，充当中间的分割线 */
.phone-row {
  display: flex;
}
.phone-row__itu {
  width: 100px;
  flex: none;
}
.phone-row .phone-row__itu /deep/ .el-input__inner {
  background: #F5F7FA;
  border-radius: 6px 0 0 6px;
}
.phone-row__input {
  flex: 1;
  margin-left: -1px;
}
.phone-row .phone-row__input /deep/ .el-input__inner {
  background: #FFFFFF;
  border-radius: 0 6px 6px 0;
}

.ms-content .el-input__inner {
  background: rgba(246, 248, 250, 1);
  line-height: normal;
  font-size: 14px;
  color: rgba(98, 109, 116, 1);
}
.captcha .el-input {
  width: 68%;
  display: inline-block;
}
.captcha-img {
  height: 40px;
  width: 30%;
  float: right;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
}
.captcha-img img {
  width: 100%;
  height: 40px;
}
.captcha-img:hover .cover {
  z-index: 1;
}
.cover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: rgba(123, 139, 137, 0.6);
  background-image: url(../../assets/img/captcha-refresh.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
}
.send-code-info .el-input {
  width: 68%;
  display: inline-block;
}
.send-code-btn {
  float: right;
  width: 30%;
  height: 40px;
  padding: 0;
}
.el-input-group__append,
.el-input-group__prepend {
  background: rgba(147, 165, 186, 1);
  border-radius: 8px 0px 0px 8px;
  color: rgba(255, 255, 255, 1);
}

.fg-done {
  text-align: center;
  padding: 10px 0 0;
}
.fg-done__icon {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  border-radius: 50%;
  background: #00b42a;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}
.fg-done__title {
  margin-top: 20px;
  font-size: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.fg-done__desc {
  margin-top: 14px;
  font-size: 13px;
  line-height: 22px;
  color: #9b9b9c;
  text-align: center;
  /* 文案里的 \n 用来控制断行位置，让两句话各占一行 */
  white-space: pre-line;
}
.fg-done__countdown {
  margin: 10px 0 24px;
  font-size: 13px;
  color: #9b9b9c;
}
</style>
